import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PaginatedResultModel } from '@data-layer/models/common';
import { HtsClassificationHistoryItemModel } from '../models/common/hts-classification-history-item.model';
import { HtsClassificationHistorySearchModel } from '../models/common/hts-classification-history-search.model';

@Injectable({
  providedIn: 'root',
})
export class HtsClassificationHistoryRepository {
  constructor(private apiService: ApiService) {}

  public search(
    companyId: number,
    params?: Omit<HtsClassificationHistorySearchModel, 'companyId'>,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<HtsClassificationHistoryItemModel>> {
    return this.apiService.get<PaginatedResultModel<HtsClassificationHistoryItemModel>>(
      `${environment.url.companies}${companyId}/hts-classification-history`,
      { params },
      { isShowLoader },
    );
  }
}
